export default "__VITE_ASSET__BxQ0paGU__"